import styles from './PopupConfirmDialog.module.scss';
import { TransparentButton } from '../TransparentButton/TransparentButton';
import { ReactNode } from 'react';

interface PopupConfirmDialogProps {
    title: string;
    description: string;
    show: boolean;
    onClose?: () => void;
    onConfirm?: () => void;
    children?: ReactNode;
    cancelLabel?: string;
    confirmLabel?: string;
    confirmVariant?: 'success' | 'danger';
}

export const PopupConfirmDialog = ({
    show,
    onClose,
    onConfirm,
    title,
    description,
    children,
    cancelLabel = 'Cancel',
    confirmLabel = 'Continue',
    confirmVariant = 'success',
}: PopupConfirmDialogProps) => {
    if (!show) return null;

    return (
        <div className={styles.background} onClick={onClose}>
            <div
                className={styles.container}
                onClick={(e) => {
                    e.stopPropagation();
                }}
            >
                <div className={styles.title}>{title}</div>
                <div className={styles.subTitle}>
                    {description}
                    {children}
                </div>

                <div className={styles.row}>
                    {onClose && (
                        <TransparentButton outline onClick={onClose} noMargin>
                            {cancelLabel}
                        </TransparentButton>
                    )}
                    {onConfirm && (
                        <div
                            className={`${styles.confirmButton} ${
                                confirmVariant === 'danger' ? styles.danger : styles.success
                            }`}
                            onClick={onConfirm}
                        >
                            {confirmLabel}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
